var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgCustomLink(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 12,
    viewBox: "0 0 20 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20 2V8C20 9.1 19.1 10 18 10H17V8H18V2H2V8H8V10H2C0.9 10 0 9.1 0 8V2C0 0.9 0.9 0 2 0H18C19.1 0 20 0.9 20 2ZM12.5 12L13.59 9.59L16 8.5L13.59 7.41L12.5 5L11.41 7.41L9 8.5L11.41 9.59L12.5 12ZM15 7L15.62 5.62L17 5L15.62 4.38L15 3L14.38 4.38L13 5L14.38 5.62L15 7ZM12.5 12L13.59 9.59L16 8.5L13.59 7.41L12.5 5L11.41 7.41L9 8.5L11.41 9.59L12.5 12ZM15 7L15.62 5.62L17 5L15.62 4.38L15 3L14.38 4.38L13 5L14.38 5.62L15 7Z",
    fill: "#333333"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCustomLink);
export default __webpack_public_path__ + "static/media/custom-link.05f89c1c40a7d3c5c1c387bf9808f5ef.svg";
export { ForwardRef as ReactComponent };